import React, { useState } from 'react'
import TechnologyWorkDeveloper from '../modals/TechnologyDeveloper'
import GetAQuote from '../modals/TechnologyWorkModal';

function Awosomeservices({ solutions, id, paddingClass }) {
    const [openModal, setOpenModal] = useState(false);
    const [openModalSolutions, setOpenModalSolutions] = useState(false);
    const [calculateModal, setCalculateModal] = useState(false);
    const [appName, setAppName] = useState('');
    const toggle = (button) => {
        setOpenModal(!openModal)
        if (button === 'Calculate your cost') {
            setCalculateModal(true)
        }
        else
            setCalculateModal(false)
    }
    const solutionToggle = (project) => {
        setOpenModalSolutions(!openModalSolutions);
        if (project)
            setAppName(project)
    }
    return (
        <section className={`r-bg-i ${paddingClass ? paddingClass : 'sec-pad'} `} id={id}>
            <TechnologyWorkDeveloper openModal={openModal} toggle={toggle} type={'solutions'} calculateModal={calculateModal} />
            <GetAQuote openModal={openModalSolutions} toggle={solutionToggle} buttonName={'Get A Free Demo'} appName={appName} />
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="sec-heading text-center pera-block">
                            <h2>{solutions.heading}</h2>
                            <p className='mt30'>{solutions.p}</p>
                        </div>
                    </div>
                </div>

                <div className="row mt30">
                    {solutions.solutions.map((data, index) =>

                        <div className={solutions.bootstrapClass} data-aos="fade-up" data-aos-delay="100" key={index}>
                            {data.link &&
                                //  <a href={`https://noorisys.com/${data.link}`} target='_blank' rel='noreferrer'>
                                <div className={`ree-card ${data.class} ${solutions.fixHeight}`} onClick={(e) => solutionToggle(data.heading)} style={{ cursor: 'pointer' }}>
                                    <div className="creative-cntnt">
                                        <h4 className="mb15"> {data.heading}</h4>
                                        <p dangerouslySetInnerHTML={{ __html: data.p }}></p>
                                    </div>
                                    {solutions.image && <div className="creative-img mt30"><img src={data.img} alt={data.link} className="img-fluid " /></div>}
                                </div>
                                // </a>
                            }
                            {!data.link &&
                                <div className={`ree-card ${data.class} ${solutions.fixHeight}`}>
                                    <div className="creative-cntnt">
                                        <h4 className="mb15"> {data.heading}</h4>
                                        <p dangerouslySetInnerHTML={{ __html: data.p }}></p>
                                    </div>
                                    {solutions.image && <div className="creative-img mt30"><img src={data.img} alt="App Development" className="img-fluid " /></div>}
                                    {data.button && (data.type === 'link' ? <a className='ree-card-content-link' href={data.url} style={{ cursor: 'pointer' }} ><h2 className='ree-card-link '>{data.button}<i className="fas fa-arrow-right fa-btn" aria-hidden="true"></i></h2></a> : <div className='ree-card-content-link' style={{ cursor: 'pointer' }} onClick={(e) => toggle(data.button)}><h2 className='ree-card-link '>{data.button}<i className="fas fa-arrow-right fa-btn" aria-hidden="true"></i></h2></div>)}
                                </div>
                            }
                        </div>

                    )}
                </div>

            </div>
        </section>
    )
}

export default Awosomeservices